<template>
  <v-container>
    <v-row>
      <v-alert type="info" v-show="message">{{ message }}</v-alert>
    </v-row>
    <v-row v-if="isAdmin">
      <v-col cols="12">
        <v-expansion-panels v-model="panel">
          <v-expansion-panel>
            <v-expansion-panel-header class="title purple lighten-1 white--text">Admin Actions</v-expansion-panel-header>

            <v-expansion-panel-content class="purple lighten-1">
              <v-btn color="purple darken-3" dark class="ml-3 mr-3 my-2" to="/marks">
                <v-icon left>mdi-check</v-icon>Review Marks
              </v-btn>
              <v-btn color="purple darken-3" dark class="ml-3 mr-3 my-2" to="/schoolyears">
                <v-icon left>mdi-calendar</v-icon>School Years
              </v-btn>
              <v-btn color="purple darken-3" dark class="ml-3 mr-3 my-2" to="/teachers">
                <v-icon left>mdi-account-music</v-icon>Teachers
              </v-btn>
              <v-btn color="purple darken-3" dark class="ml-3 mr-3 my-2" to="/fees">
                <v-icon left>mdi-text-box-check-outline</v-icon>Exam Fees
              </v-btn>
              <v-btn color="purple darken-3" dark class="ml-3 mr-3 my-2" to="/locations">
                <v-icon left>mdi-office-building</v-icon>Locations
              </v-btn>
              <v-btn color="purple darken-3" dark class="ml-3 mr-3 my-2" to="/reports">
                <v-icon left>mdi-file-download-outline</v-icon>Reports
              </v-btn>
              <v-btn color="purple darken-3" dark class="ml-3 mr-3 my-2" to="/pendingaccounts">
                <v-icon left>mdi-account-check</v-icon>Registrations
              </v-btn>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel :key="0">
            <v-expansion-panel-header class="title purple lighten-2 white--text">
              {{
              account
              ? `Impersonating ${account.firstName} ${account.lastName}`
              : "Select parent to impersonate"
              }}
            </v-expansion-panel-header>
            <v-expansion-panel-content class="purple lighten-2">
              <v-card>
                <v-card-title>
                  Parents
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-card-title>
                <v-data-table
                  :loading="loading"
                  loading-text="Loading... Please wait"
                  :headers="adminHeaders"
                  :items="parents"
                  :server-items-length="parentsTotal"
                  :options.sync="options"
                  :footer-props="{'items-per-page-options':[1,10, 20, 30]}"
                >
                  <template v-slot:item.actions="{ item }">
                    <v-layout :justify-end="true" v-if="item.firstName !== 'Temporary'">
                      <v-chip-group column>
                        <v-chip label @click="loadParent(item.id)" color="purple darken-2" dark>
                          <v-icon left small>mdi-account-supervisor</v-icon>Impersonate
                        </v-chip>
                        <v-chip label @click="goTransactions(item.id)" color="purple darken-2" dark>
                          <v-icon left small>mdi-credit-card-outline</v-icon>Tnxs
                        </v-chip>
                        <v-chip
                          label
                          @click="goCreditRecords(item.id)"
                          color="purple darken-2"
                          dark
                        >
                          <v-icon left small>mdi-cash-usd-outline</v-icon>Credit
                        </v-chip>
                        <v-icon
                          v-if="item.childrenCount === 0"
                          @click="deleteParent(item)"
                        >mdi-delete</v-icon>
                      </v-chip-group>
                    </v-layout>
                  </template>
                </v-data-table>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <v-row v-if="account">
      <v-col>
        <v-card>
          <v-card-title>
            Children
            <AccountCreditChip class="ml-2" />
            <v-spacer></v-spacer>
            <CheckOutBtn v-if="schoolYear || isAdmin" />
            <v-btn color="primary" dark class="ml-3 mr-3 my-2" @click.stop="predialog = true">
              <v-icon left>mdi-account-plus</v-icon>Add Child
            </v-btn>
            <v-btn
              v-if="isAdmin && account.children.length > 0"
              color="purple"
              dark
              class="mr-3 my-2"
              @click.stop="movedialog = true"
            >
              <v-icon left>mdi-account-child</v-icon>Move Children
            </v-btn>

            <v-dialog v-model="predialog" max-width="450">
              <v-card>
                <v-card-title>Previous Exam Registrations?</v-card-title>
                <v-card-text>Are you adding a child who had been registered in the previous system?</v-card-text>
                <v-card-actions>
                  <v-btn text @click.stop="predialog = false">Cancel</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click.stop="addLinkedChild()">Yes, Link Child</v-btn>
                  <v-btn color="primary" @click.stop="addNewChild()">No, Add New Child</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="linkdialog" max-width="400">
              <v-card>
                <v-card-title>Link Child</v-card-title>
                <v-card-text>
                  <v-form ref="lform" lazy-validation>
                    <v-container>
                      <v-row>
                        <v-col>
                          <v-text-field
                            v-model="linkMemberId"
                            type="number"
                            label="Account Id in previous system"
                            :rules="memberIdRules"
                            prepend-icon="mdi-account-arrow-left"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-text-field
                            v-model="linkFirstName"
                            label="Child's firstname"
                            :rules="firstNameRules"
                            required
                            type="text"
                            prepend-icon="mdi-account"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click.stop="linkdialog = false">Cancel</v-btn>
                  <v-btn color="primary" @click="linkStudent">Link Child</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="movedialog" max-width="500">
              <v-card>
                <v-card-title>Move Children to Another Parent</v-card-title>
                <v-card-text>
                  <v-form ref="moveform" :lazy-validation="false">
                    <v-text-field
                      v-model="parentEmail"
                      label="E-Mail of destination parent"
                      required
                      prepend-icon="mdi-email"
                      type="text"
                      :rules="emailRules"
                      :counter="100"
                    ></v-text-field>
                    <v-btn
                      @click="validateParent"
                      :color="parentIdToMoveTo === 0 ? 'error' : 'success'"
                    >
                      <v-icon v-if="parentIdToMoveTo === 0" left>mdi-close</v-icon>
                      <v-icon v-if="parentIdToMoveTo !== 0" left>mdi-check</v-icon>Validate
                    </v-btn>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click.stop="movedialog = false">Cancel</v-btn>
                  <v-btn
                    :disabled="parentIdToMoveTo === 0"
                    color="primary"
                    @click="moveChildren"
                  >Move Children</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="dialog" persistent>
              <v-form ref="form" lazy-validation>
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                    <v-spacer></v-spacer>
                    <v-chip
                      v-if="editedItem.id > 0"
                      label
                      outlined
                      :color="editedItem.color"
                      class="font-weight-bold mr-2"
                    >{{ editedItem.id }}</v-chip>
                    <v-avatar :color="editedItem.color">
                      <span class="white--text headline">{{ editedItem.chipInitials }}</span>
                    </v-avatar>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="6">
                          <v-text-field
                            v-model="editedItem.childFirstName"
                            label="Child First Name"
                            prepend-icon="mdi-face"
                            :counter="50"
                            :rules="childFirstNameRules"
                            :disabled="editedIndex !== -1"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field
                            v-model="editedItem.childLastName"
                            label="Child Last Name"
                            prepend-icon="mdi-license"
                            :counter="50"
                            :rules="childLastNameRules"
                            :disabled="editedIndex !== -1"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6" sm="3">
                          <v-menu
                            ref="bdayMenu"
                            v-model="bdayMenu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="editedItem.birthDay"
                                label="Birthday date"
                                prepend-icon="mdi-cake"
                                readonly
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              ref="picker"
                              v-model="editedItem.birthDay"
                              :max="new Date().toISOString().substr(0, 10)"
                              min="1950-01-01"
                              @change="saveBday"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="2" sm="1">
                          <v-switch v-model="editedItem.overrideChipInitials"></v-switch>
                        </v-col>
                        <v-col cols="4" sm="2">
                          <v-text-field
                            v-model="editedItem.chipInitials"
                            label="Initials"
                            :counter="2"
                            :disabled="!editedItem.overrideChipInitials"
                            :rules="chipInitialsRules"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-row>
                            <span>Color</span>
                          </v-row>
                          <v-row justify="space-between">
                            <v-btn color="red" fab x-small @click="editedItem.color = 'red'"></v-btn>
                            <v-btn color="pink" fab x-small @click="editedItem.color = 'pink'"></v-btn>
                            <v-btn color="purple" fab x-small @click="editedItem.color = 'purple'"></v-btn>
                            <v-btn
                              color="deep-purple"
                              fab
                              x-small
                              @click="editedItem.color = 'deep-purple'"
                            ></v-btn>
                            <v-btn color="indigo" fab x-small @click="editedItem.color = 'indigo'"></v-btn>
                            <v-btn
                              color="light-blue"
                              fab
                              x-small
                              @click="editedItem.color = 'light-blue'"
                            ></v-btn>
                            <v-btn color="teal" fab x-small @click="editedItem.color = 'teal'"></v-btn>
                            <v-btn color="orange" fab x-small @click="editedItem.color = 'orange'"></v-btn>
                            <v-btn
                              color="deep-orange"
                              fab
                              x-small
                              @click="editedItem.color = 'deep-orange'"
                            ></v-btn>
                            <v-btn color="brown" fab x-small @click="editedItem.color = 'brown'"></v-btn>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="close">Cancel</v-btn>
                    <v-btn color="primary" @click="save">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-dialog>
          </v-card-title>
          <v-data-table v-if="account" :headers="headers" :items="account.children">
            <template v-slot:item.id="{ item }">
              <v-chip label outlined :color="item.color" class="font-weight-bold">{{ item.id }}</v-chip>
            </template>

            <template v-slot:item.childFirstName="{ item }">
              <v-avatar :color="item.color" size="36">
                <span class="white--text">
                  <strong>{{ item.chipInitials }}</strong>
                </span>
              </v-avatar>
              <strong>&nbsp;&nbsp;{{ item.childFirstName }}</strong>
            </template>

            <template v-slot:item.childLastName="{ item }">
              <strong>{{ item.childLastName }}</strong>
            </template>

            <template v-slot:item.birthDay="{ item }">
              {{
              item.birthDay | formatDate
              }}
            </template>

            <template v-slot:item.actions="{ item }">
              <v-layout :justify-end="true">
                <v-chip-group column>
                  <v-chip
                    v-if="schoolYear || isAdmin"
                    label
                    :to="{
                      name: 'ExamRegistration',
                      params: { childId: item.id },
                    }"
                    :color="item.color"
                  >
                    <v-icon color="white" left small>mdi-calendar-check</v-icon>
                    <span class="white--text">Register&nbsp;for&nbsp;Exam</span>
                  </v-chip>
                  <v-chip
                    label
                    @click="historyItem(item)"
                    :disabled="item.examRegistrations.length === 0"
                    :color="item.color"
                  >
                    <v-icon color="white" left small>mdi-calendar-text</v-icon>
                    <span class="white--text">Exam&nbsp;History</span>
                  </v-chip>
                </v-chip-group>

                <v-icon class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
                <v-icon
                  v-if="item.examRegistrations.length === 0"
                  @click="deleteItem(item)"
                >mdi-delete</v-icon>
              </v-layout>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { errorMessageMixin, storeMixin, validationMixin } from "../shared";
import CheckOutBtn from "../components/CheckOutBtn.vue";
import AccountCreditChip from "../components/AccountCreditChip.vue";
import * as axios from "axios";

export default {
  name: "Home",
  mixins: [errorMessageMixin, storeMixin, validationMixin],
  data() {
    return {
      message: "",
      search: "",
      panel: [0],
      predialog: false,
      movedialog: false,
      dialog: false,
      linkdialog: false,
      linkMemberId: 0,
      memberIdRules: [
        v => !!v || "Account Id is required",
        v => v > 0 || "Account Id must be positive"
      ],
      linkFirstName: "",
      firstNameRules: [v => !!v || "First name is required"],
      bdayMenu: false,
      headers: [
        {
          text: "Child Id",
          value: "id",
          align: "start"
        },
        {
          text: "Child First Name",
          value: "childFirstName"
        },
        {
          text: "Child Last Name",
          value: "childLastName"
        },
        {
          text: "Birthday",
          value: "birthDay"
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          align: "end"
        }
      ],
      adminHeaders: [
        {
          text: "FirstName",
          value: "firstName",
          align: "start"
        },
        {
          text: "Last Name",
          value: "lastName"
        },
        {
          text: "Email",
          value: "emailAddress"
        },
        {
          text: "Phone",
          value: "phoneNumber"
        },
        {
          text: "Registered Children",
          value: "childrenCount",
          sortable: false
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          align: "end"
        }
      ],
      loading: false,
      options: {},
      editedIndex: -1,
      editedItem: {
        childFirstName: "",
        childLastName: this.defaultLastName(),
        birthDay: new Date().toISOString().substr(0, 10),
        color: "red",
        chipInitials: "",
        overrideChipInitials: false
      },
      defaultItem: {
        childFirstName: "",
        childLastName: this.defaultLastName(),
        birthDay: new Date().toISOString().substr(0, 10),
        color: "red",
        chipInitials: "",
        overrideChipInitials: false
      },
      childFirstNameRules: [
        v => !!v || "Child first name is required.",
        v =>
          (v && v.length <= 50) ||
          "Child first name must be less than 50 characters"
      ],
      childLastNameRules: [
        v => !!v || "Child last name is required.",
        v =>
          (v && v.length <= 50) ||
          "Child last name must be less than 50 characters"
      ],
      chipInitialsRules: [
        v =>
          !v || v.length <= 2 || "Chip Initials can only be up to 2 characters"
      ],
      parentEmail: "",
      parentIdToMoveTo: 0
    };
  },
  async created() {
    console.log("home created");
    this.$store.state.fullScreenLoading = true;

    await this.loadSchoolYear();
    if (!this.isAdmin) {
      await this.loadAccount(this.$store.state.user.id);
      let parentMessage = "";
      if (!this.schoolYear) {
        parentMessage =
          "Welcome! There is no current exam registration window. Please try again or contact TIKM directly.";
      } else {
        if (this.schoolYear.isTheoreticalExamsOnly) {
          parentMessage =
            "Welcome! The current exam registration window is for Theoretical exams only. Eligible children will be able to register for exams.";
        } else {
          parentMessage =
            "Welcome! The current exam registration window is for comprehensive exams.";
        }
      }
      this.$store.state.error = parentMessage;
      this.$store.state.snackbarColor = "info";
      this.$store.state.snackbar = true;
    }
    try {
      await this.loadSubjects();
      await this.loadTeachers();
      await this.loadExamFees();
      if (this.isAdmin && this.parents.length === 0) {
        console.log("im loading parents");
        await this.loadParents();
        this.panel = [0];
      }
      this.$store.state.fullScreenLoading = false;
    } catch (err) {
      this.$store.state.fullScreenLoading = false;
      this.$store.state.error = this.errorMessage(err);
      this.$store.state.snackbar = true;
      console.log(err);
    }
  },
  props: {
    msg: String
  },
  components: { CheckOutBtn, AccountCreditChip },
  computed: {
    ...mapState(["account", "user", "parents", "parentsTotal", "schoolYear"]),
    formTitle() {
      return this.editedIndex === -1 ? "Add Child" : "Edit Child";
    },
    ...mapGetters(["isAdmin"])
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    bdayMenu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    "editedItem.childFirstName"(val) {
      //console.log("im in watch", val, this.editedItem.overrideChipInitials);
      if (!this.editedItem.overrideChipInitials) {
        this.editedItem.chipInitials = val.substr(0, 2);
      }
    },
    options: {
      async handler() {
        await this.loadParents(this.search);
      },
      deep: true
    },
    search: async function() {
      await this.loadParents(this.search);
    },
    parentEmail() {
      console.log("parent email changed");
      this.parentIdToMoveTo = 0;
    }
  },
  methods: {
    ...mapActions([
      "addChildAction",
      "updateChildAction",
      "getSubjectsAction",
      "getTeachersAction",
      "getExamFeesAction",
      "getParentsAction",
      "getSchoolYearAction",
      "deleteChildAction",
      "linkStudentAction",
      "deleteParentAction",
      "moveChildrenAction",
      "logout"
    ]),
    async loadSchoolYear() {
      await this.getSchoolYearAction();
    },
    async loadSubjects() {
      await this.getSubjectsAction();
    },
    async loadTeachers() {
      await this.getTeachersAction();
    },
    async loadExamFees() {
      await this.getExamFeesAction();
    },
    async loadParents(search) {
      console.log("load parents");

      this.loading = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      console.log("this.options", this.options);
      console.log("sortBy, sortDesc", sortBy, sortDesc);
      console.log("page, itemsPerPage", page, itemsPerPage);

      let sortExpression = "Id";
      if (sortBy && sortDesc && sortBy.length == 1 && sortDesc.length == 1) {
        sortExpression = sortBy[0];
        if (sortDesc[0]) {
          sortExpression = sortExpression + " desc";
        }
      }

      try {
        await this.getParentsAction({
          token: this.$store.state.token,
          page: page,
          itemsPerPage: itemsPerPage,
          sortBy: sortExpression,
          search: search
        });
        if (this.parents == null) {
          console.log("im logged out: cause of error?");
          this.logout();
          console.log("im logged out");
          this.$router.go();
        }
      } catch (err) {
        this.$store.state.error = this.errorMessage(err);
        this.$store.state.snackbar = true;
        console.log(err);
      }
      this.loading = false;
    },
    async loadParent(id) {
      console.log("load parent", id);
      await this.loadAccount(id);
      this.panel = [];
    },
    async goTransactions(id) {
      await this.loadAccount(id);
      this.panel = [];
      this.$router.push({ name: "Transactions" });
    },
    async goCreditRecords(id) {
      await this.loadAccount(id);
      this.panel = [];
      this.$router.push({ name: "CreditRecords" });
    },
    historyItem(item) {
      console.log("item", item);
      this.$router.push({ name: "History", params: { childId: item.id } });
    },

    editItem(item) {
      this.editedIndex = this.account.children.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.birthDay = this.editedItem.birthDay.substr(0, 10);
      this.dialog = true;
    },
    async deleteParent(item) {
      console.log("delete parent", item);
      if (confirm("Remove " + item.firstName + " " + item.lastName + "?")) {
        this.$store.state.fullScreenLoading = true;
        const deleteParentModel = {
          accountId: item.id
        };
        try {
          await this.deleteParentAction({
            model: deleteParentModel,
            token: this.$store.state.token
          });
          // write a message
          console.log("delete done");
          await this.loadParents(this.search);
        } catch (err) {
          console.log("im in error");
          this.$store.state.error = this.errorMessage(err);
          this.$store.state.snackbar = true;
          console.log(err);
        }
        console.log("after the try");
        this.$store.state.fullScreenLoading = false;
      }
    },

    async deleteItem(item) {
      if (confirm("Remove " + item.childFirstName + "?")) {
        this.$store.state.fullScreenLoading = true;
        const deleteChildModel = {
          accountId: this.account.id,
          childId: item.id
        };
        console.log("deleteChildModel", deleteChildModel);
        try {
          await this.deleteChildAction({
            model: deleteChildModel,
            token: this.$store.state.token
          });
          // write a message
          console.log("delete done");
        } catch (err) {
          console.log("im in error");
          this.$store.state.error = this.errorMessage(err);
          this.$store.state.snackbar = true;
          console.log(err);
        }
        console.log("after the try");
        this.$store.state.fullScreenLoading = false;
      }
    },

    addNewChild() {
      this.predialog = false;
      this.dialog = true;
    },

    addLinkedChild() {
      this.predialog = false;
      this.linkdialog = true;
    },

    close() {
      this.message = "";
      this.dialog = false;
      this.predialog = false;
      this.linkdialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    async linkStudent() {
      this.$store.state.snackbar = false;
      if (!this.$refs.lform.validate()) {
        return;
      }
      console.log("im valid", this.linkMemberId, this.linkFirstName);
      this.$store.state.fullScreenLoading = true;

      try {
        let linkStudentModel = {
          accountId: this.$store.state.account.id,
          memberId: this.linkMemberId,
          memberFirstName: this.linkFirstName
        };

        await this.linkStudentAction({
          model: linkStudentModel,
          token: this.$store.state.token
        });
        this.close();

        this.$store.state.error =
          "Student " + this.linkMemberId + " successfully linked to account.";
        this.$store.state.snackbarColor = "success";
        this.$store.state.snackbar = true;
        this.$store.state.fullScreenLoading = false;
      } catch (err) {
        this.$store.state.fullScreenLoading = false;
        this.$store.state.error = this.errorMessage(err);
        this.$store.state.snackbar = true;
        console.log(err);
      }
    },

    async save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      console.log("im valid");

      if (this.editedIndex > -1) {
        //Object.assign(this.desserts[this.editedIndex], this.editedItem);
        let updateChildModel = Object.assign({}, this.editedItem);
        updateChildModel.accountId = this.$store.state.account.id;
        console.log("updateChildModel", updateChildModel);
        try {
          await this.updateChildAction({
            model: updateChildModel,
            token: this.$store.state.token
          });
          this.close();
          this.messsage = "Child edited.";
        } catch (err) {
          this.$store.state.error = this.errorMessage(err);
          this.$store.state.snackbar = true;
          console.log(err);
        }
      } else {
        this.$store.state.snackbar = false;
        let matchFound = false;
        // check if the name is valid.
        this.$store.state.account.children.forEach(element => {
          if (
            element.childFirstName.toUpperCase() ===
              this.editedItem.childFirstName.toUpperCase() &&
            element.childLastName.toUpperCase() ===
              this.editedItem.childLastName.toUpperCase()
          ) {
            matchFound = true;
          }
        });
        if (matchFound) {
          console.log("im found!");
          this.$store.state.error =
            this.editedItem.childFirstName +
            " " +
            this.editedItem.childLastName +
            " has already been added.";
          this.$store.state.snackbar = true;
          return;
        }
        console.log("this.editedItem", this.editedItem);
        let addChildModel = Object.assign({}, this.editedItem);
        addChildModel.accountId = this.$store.state.account.id;
        console.log("addChildModel", addChildModel);
        try {
          await this.addChildAction({
            model: addChildModel,
            token: this.$store.state.token
          });
          this.close();
          this.messsage = "Child added.";
        } catch (err) {
          this.$store.state.error = this.errorMessage(err);
          this.$store.state.snackbar = true;
          console.log(err);
        }
      }
    },

    saveBday(date) {
      this.$refs.bdayMenu.save(date);
    },
    defaultLastName() {
      return this.$store.state.account
        ? this.$store.state.account.lastName
        : "";
    },
    async validateParent() {
      const parent = await this.findParent();
      console.log("parent found is", parent);
      if (!parent) {
        console.log("set to 0");
        this.parentIdToMoveTo = 0;
      } else {
        console.log("set to parent.id", parent.id);
        this.parentIdToMoveTo = parent.id;
      }
    },
    async findParent() {
      if (!this.$refs.moveform.validate()) {
        console.log("invalid form");
        return null;
      }
      try {
        axios.defaults.headers.common[
          "Authorization"
        ] = this.$store.state.token;
        const response = await axios.get(
          process.env.VUE_APP_SERVICE_URL + `/parent?email=` + this.parentEmail
        );
        console.log("response", response);
        if (response.status != 200) {
          throw Error(response.message);
        }
        if (!response.data) {
          return null;
        }
        console.log("response.data", response.data);
        let parent = response.data;
        if (typeof parent !== "object") {
          parent = null;
        }
        return parent;
      } catch (err) {
        this.$store.state.error = this.errorMessage(err);
        this.$store.state.snackbar = true;
        console.log(err);
      }
      return null;
    },
    async moveChildren() {
      this.$store.state.snackbar = false;
      console.log("im valid", this.parentIdToMoveTo, this.account.id);
      this.$store.state.fullScreenLoading = true;

      try {
        let moveChildrenModel = {
          adminId: this.$store.state.user.id,
          accountIdFrom: this.$store.state.account.id,
          accountIdTo: this.parentIdToMoveTo
        };

        await this.moveChildrenAction({
          model: moveChildrenModel,
          token: this.$store.state.token
        });
        this.close();

        this.$store.state.error = "Children successfully moved to account.";
        this.$store.state.snackbarColor = "success";
        this.$store.state.snackbar = true;
        this.$store.state.fullScreenLoading = false;
      } catch (err) {
        this.$store.state.fullScreenLoading = false;
        this.$store.state.error = this.errorMessage(err);
        this.$store.state.snackbar = true;
        console.log(err);
      }
    }
  }
};
</script>
